import React from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { Add, AddAlt } from '@mint-lib/icons';
import { Button } from '@mint-lib/tw-components';

type SubmitButtonsProps = {
  step: number;
  isSure: boolean;
  onNextStep: () => void;
  onAcceptUpdate: () => void;
  isLoadingAccept: boolean;
  onAcceptNewCreate: () => void;
};

const SubmitButtons = ({
  step,
  isSure,
  isLoadingAccept,
  onNextStep,
  onAcceptUpdate,
  onAcceptNewCreate,
}: SubmitButtonsProps) => {
  const { t } = useTranslation('@mint-lib/recommendations-circuit');

  if (step === 0) {
    return (
      <Button
        onClick={onNextStep}
        disabled={!isSure}
        variant="contained"
        color="primary"
        size="large"
      >
        <AddAlt />
        {t('Next')}
      </Button>
    );
  }

  return (
    <>
      <Button
        disabled={isLoadingAccept}
        onClick={onAcceptNewCreate}
        variant="text"
        color="primary"
        size="large"
      >
        {<Add />}
        {t('Create New')}
      </Button>
      <Button
        disabled={isLoadingAccept}
        onClick={onAcceptUpdate}
        variant="contained"
        color="primary"
        size="large"
      >
        {t('Update Current')}
      </Button>
    </>
  );
};

export default SubmitButtons;
